export type ViewerEdge = {
	source: string
	sourceHandle?: string | null
	target: string
	targetHandle?: string | null
}

export const connectedViewerGeometry = (
	nodeID: string,
	edges: ViewerEdge[],
	outputs: ReadonlyMap<string, unknown>,
) =>
	edges.flatMap((edge) => {
		if (
			edge.target !== nodeID ||
			edge.targetHandle !== "geometry" ||
			!outputs.has(edge.source)
		) {
			return []
		}
		const output = outputs.get(edge.source)
		if (
			edge.sourceHandle &&
			output !== null &&
			typeof output === "object" &&
			edge.sourceHandle in output
		) {
			return [(output as Record<string, unknown>)[edge.sourceHandle]]
		}
		return [output]
	})
